import Page from 'flarum/common/components/Page';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import app from 'flarum/forum/app';

export default class QuantumSurfLandingPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Hālau Nalu - Quantum Surf School');
    app.setTitleCount(0);
  }

  view() {
    const isLoggedIn = !!(app.session && app.session.user);

    return (
      <div className="QuantumSurfLandingPage">
        {/* Hero Section */}
        <section className="QuantumSurf-hero">
          <div className="QuantumSurf-hero-image">
            <img 
              src="https://deep-integrations.com/assets/files/2026-03-30/1774856138-383946-quantum-surfing-ecourse.png" 
              alt="Quantum Surfing - Hālau Nalu"
            />
          </div>
          <div className="QuantumSurf-hero-overlay"></div>
          <div className="QuantumSurf-hero-content">
            <div className="container">
              <div className="QuantumSurf-hero-text">
                <div className="QuantumSurf-badge">8-Week Transformational Journey</div>
                <h1 className="QuantumSurf-title">
                  Hālau Nalu
                  <span className="QuantumSurf-subtitle-inline">The Quantum Surf School of the Soul</span>
                </h1>
                <p className="QuantumSurf-tagline">
                  Where ancient Hawaiian wisdom meets quantum physics, nervous system science, and the art of riding life's waves with grace
                </p>
                {!isLoggedIn && (
                  <button 
                    className="Button Button--primary QuantumSurf-cta" 
                    onclick={() => this.handleSignUp()}
                  >
                    SIGN UP
                  </button>
                )}
                {isLoggedIn && (
                  <a 
                    href={app.route('courses')} 
                    className="Button Button--primary QuantumSurf-cta"
                  >
                    ACCESS YOUR COURSES
                  </a>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Introduction Section */}
        <section className="QuantumSurf-intro">
          <div className="container">
            <div className="QuantumSurf-intro-content">
              <p className="QuantumSurf-intro-greeting">
                <em>Aloha, Keiki. Welcome to the Lanai.</em>
              </p>
              <p className="QuantumSurf-intro-text">
                I am Uncle Pata. I used to sit in ice caves counting breaths until my toes turned blue. 
                Then I discovered the Pacific. Same ocean, different temperature.
              </p>
              <p className="QuantumSurf-intro-text">
                The mind is not a mountain to be conquered—it is a <em>moana</em> (ocean) to be understood. 
                You cannot master the wave by fighting it. You must learn to read the <em>nalu</em> (swell), 
                feel the <em>mana</em> (power) in your bones, and remember that you are not separate from the water—
                you <strong>are</strong> the water, temporarily shaped like a surfer.
              </p>
            </div>
          </div>
        </section>

        {/* What You'll Learn Section */}
        <section className="QuantumSurf-curriculum">
          <div className="container">
            <h2 className="QuantumSurf-section-title">Your 8-Week Journey</h2>
            <p className="QuantumSurf-section-subtitle">
              Each week blends Hawaiian embodiment practices, quantum principles, and nervous system regulation
            </p>
            
            <div className="QuantumSurf-weeks">
              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Week 1</div>
                <h3 className="QuantumSurf-week-title">KAI — The Glassy Surface</h3>
                <p className="QuantumSurf-week-desc">The Observer Effect & The Still Mind. Learn to watch your thoughts like sets rolling in.</p>
              </div>

              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Week 2</div>
                <h3 className="QuantumSurf-week-title">HONUA — The Reef of Kindness</h3>
                <p className="QuantumSurf-week-desc">Ahimsa & Non-Violence. Discover how kindness ripples through the quantum field.</p>
              </div>

              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Week 3</div>
                <h3 className="QuantumSurf-week-title">KILO — Reading the Swell</h3>
                <p className="QuantumSurf-week-desc">Self-Study & Nervous System Mapping. Become the observer of your internal weather.</p>
              </div>

              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Week 4</div>
                <h3 className="QuantumSurf-week-title">IMUA — The Paddle Out</h3>
                <p className="QuantumSurf-week-desc">Disciplined Heat & Quantum Tunneling. Build the strength to paddle through barriers.</p>
              </div>

              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Week 5</div>
                <h3 className="QuantumSurf-week-title">HĀ — The Breath of the Tide</h3>
                <p className="QuantumSurf-week-desc">Pranayama & Cardiac Coherence. Master the breath, master the mana.</p>
              </div>

              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Week 6</div>
                <h3 className="QuantumSurf-week-title">NALU — Dropping In</h3>
                <p className="QuantumSurf-week-desc">Flow State & Single-Pointed Focus. Experience the stoke of full presence.</p>
              </div>

              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Week 7</div>
                <h3 className="QuantumSurf-week-title">MOANA — The Blue Room</h3>
                <p className="QuantumSurf-week-desc">Deep Absorption & Quantum Entanglement. Enter the barrel of consciousness.</p>
              </div>

              <div className="QuantumSurf-week">
                <div className="QuantumSurf-week-number">Week 8</div>
                <h3 className="QuantumSurf-week-title">ALOHA — The Eternal Shore</h3>
                <p className="QuantumSurf-week-desc">Integration & Return. Carry the ocean inside you back to the world.</p>
              </div>
            </div>
          </div>
        </section>

        {/* What's Included Section */}
        <section className="QuantumSurf-includes">
          <div className="container">
            <h2 className="QuantumSurf-section-title">What's Included</h2>
            
            <div className="QuantumSurf-features">
              <div className="QuantumSurf-feature">
                <div className="QuantumSurf-feature-icon">🌊</div>
                <h3>Weekly Embodiment Practices</h3>
                <p>Hawaiian-inspired movement sequences (Hula) designed to regulate your nervous system and build somatic awareness</p>
              </div>

              <div className="QuantumSurf-feature">
                <div className="QuantumSurf-feature-icon">🧠</div>
                <h3>Quantum Science Integration</h3>
                <p>Understand the physics of consciousness, observer effects, and how your attention shapes reality</p>
              </div>

              <div className="QuantumSurf-feature">
                <div className="QuantumSurf-feature-icon">💨</div>
                <h3>Breathwork & HRV Training</h3>
                <p>Master pranayama techniques and cardiac coherence to access flow states on demand</p>
              </div>

              <div className="QuantumSurf-feature">
                <div className="QuantumSurf-feature-icon">🤝</div>
                <h3>Tribal Practices (Piko)</h3>
                <p>Weekly community rituals to build brotherhood, accountability, and collective mana</p>
              </div>

              <div className="QuantumSurf-feature">
                <div className="QuantumSurf-feature-icon">📖</div>
                <h3>Daily Practices & Journaling</h3>
                <p>Structured protocols to integrate the teachings into your everyday life</p>
              </div>

              <div className="QuantumSurf-feature">
                <div className="QuantumSurf-feature-icon">🏄</div>
                <h3>Lifetime Access</h3>
                <p>Return to the material whenever you need to paddle back out and catch the next wave</p>
              </div>
            </div>
          </div>
        </section>

        {/* Who This Is For Section */}
        <section className="QuantumSurf-for">
          <div className="container">
            <h2 className="QuantumSurf-section-title">This Journey Is For You If...</h2>
            
            <div className="QuantumSurf-for-list">
              <div className="QuantumSurf-for-item">
                <span className="QuantumSurf-for-check">✓</span>
                <p>You're tired of spiritual bypassing and want practices rooted in both ancient wisdom and modern science</p>
              </div>
              <div className="QuantumSurf-for-item">
                <span className="QuantumSurf-for-check">✓</span>
                <p>You feel disconnected from your body and want to learn somatic regulation without the woo-woo</p>
              </div>
              <div className="QuantumSurf-for-item">
                <span className="QuantumSurf-for-check">✓</span>
                <p>You're seeking a masculine container that honors depth, vulnerability, and brotherhood</p>
              </div>
              <div className="QuantumSurf-for-item">
                <span className="QuantumSurf-for-check">✓</span>
                <p>You want to understand the quantum mechanics of consciousness without losing the poetry</p>
              </div>
              <div className="QuantumSurf-for-item">
                <span className="QuantumSurf-for-check">✓</span>
                <p>You're ready to stop fighting the waves and learn to ride them with grace</p>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA Section */}
        <section className="QuantumSurf-final-cta">
          <div className="container">
            <div className="QuantumSurf-final-cta-content">
              <h2 className="QuantumSurf-final-title">Your Board Is Waxed. The Tide Is Right.</h2>
              <p className="QuantumSurf-final-text">
                Bring your board. Leave your armor. The kupuna (ancestors) are paddling out with us.
              </p>
              {!isLoggedIn && (
                <button 
                  className="Button Button--primary QuantumSurf-cta-large" 
                  onclick={() => this.handleSignUp()}
                >
                  SIGN UP NOW
                </button>
              )}
              {isLoggedIn && (
                <a 
                  href={app.route('courses')} 
                  className="Button Button--primary QuantumSurf-cta-large"
                >
                  ACCESS YOUR COURSES
                </a>
              )}
              <p className="QuantumSurf-final-note">
                <em>A hui hou. (Until we meet again.)</em>
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  handleSignUp() {
    app.modal.show(SignUpModal, {
      courseEnrollmentKey: 'quantum-surf',
    });
  }
}
